import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import { DateHelper } from "@workspace/common";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import { CandidateProfileEditor } from "@workspace/portfolio/src/pages";
import { fetchJobTimelineList } from "@workspace/job/src/store/actions";
import "./ClientCandidatesTab.scss";

function ClientCandidatesTab({ id }) {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const candidatesData = useSelector(
    (state) => state?.JobStageReducer?.jobTimelineAll
  );

  useEffect(() => {
    const request = {
      allActive: true,
      jobId: id,
      page: 0,
      pageSize: 50,
    };
    dispatch(fetchJobTimelineList(request));
  }, []);

  const getStatusClass = (status) => {
    if (status === "Rejected")
      return { backgroundColor: "#EC221F", color: "white" };
    if (status === "Selected")
      return { backgroundColor: "#14AE5C", color: "white" };
    if (status === "Scheduled") return { backgroundColor: "#D9D9D9" };
    return {};
  };

  const filteredCandidates = candidatesData?.jobs?.filter((data) => {
    const submitToClientTimeline = data?.timeline?.["Submit to Client"];
    const submitToClientStatus = submitToClientTimeline?.[0]?.status;
    return submitToClientStatus === "COMPLETED";
  });

  const getInterviewStatus = (data) => {
    const firstInterviewStatus =
      data?.timeline?.["First Interview Scheduled"]?.[0]?.status;
    const secondInterviewStatus =
      data?.timeline?.["Second Interview Scheduled"]?.[0]?.status;
    const thirdInterviewStatus =
      data?.timeline?.["Third Interview Scheduled"]?.[0]?.status;
    const interviewFeedbackStatus =
      data?.timeline?.["Interview Feedback Pending"]?.[0]?.status;

    if (
      firstInterviewStatus === "REJECTED" ||
      secondInterviewStatus === "REJECTED" ||
      thirdInterviewStatus === "REJECTED"
    ) {
      return "Rejected";
    } else if (
      firstInterviewStatus === "COMPLETED" ||
      secondInterviewStatus === "COMPLETED" ||
      thirdInterviewStatus === "COMPLETED" ||
      firstInterviewStatus === "HAPPENED" ||
      secondInterviewStatus === "HAPPENED" ||
      thirdInterviewStatus === "HAPPENED"
    ) {
      return "Scheduled";
    } else if (interviewFeedbackStatus === "COMPLETED") {
      return "Selected";
    }
  };

  const handleCardClick = (candidate) => {
    setSelectedCandidate(candidate);
  };

  return (
    <div
      className="px-0 py-3"
      style={{ minWidth: "100vh", borderRight: "1px solid grey" }}
    >
      <Row>
        <Col lg={3}>
          {filteredCandidates && filteredCandidates.length > 0 ? (
            filteredCandidates.map((data, index) => {
              const candidateData = data?.candidate?.candidateSubmissionData;
              const jobData = data?.job?.jobSubmissionData;
              const interviewStatus = getInterviewStatus(data);
              return (
                <Card
                  key={index}
                  className="mb-3 cursor-pointer"
                  onClick={() => handleCardClick(data?.candidate)}
                  style={{
                    border:
                      selectedCandidate === data?.candidate
                        ? "1px solid #0A56AE"
                        : "",
                  }}
                >
                  <CardBody>
                    <Row className="mb-2">
                      <Col>
                        <div className="d-flex justify-content-between align-items-center gap-1">
                          <div>
                            <span className="h6 fw-semibold">
                              {jobData?.jobTitle}
                            </span>
                          </div>
                          <div className="d-flex flex-row gap-1 align-items-center">
                            <span className="me-2 border-rounded shadow-sm p-2">
                              {interviewStatus}
                            </span>
                            <span className="mdi mdi-arrow-right-thick"></span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col>
                        <span className="h4 fw-semibold">
                          {candidateData?.firstName} {candidateData?.lastName}
                        </span>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col>
                        <p
                          style={{
                            textAlign: "justify",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {candidateData?.profileSummary}
                        </p>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col>
                        <div className="d-flex justify-content-start flex-wrap gap-1">
                          {candidateData?.primarySkill
                            .split(",")
                            .map((skill, index) => (
                              <span
                                key={index}
                                className="border-rounded shadow-sm p-2 d-flex justify-content-center align-items-center"
                                style={{ minWidth: "100px" }}
                              >
                                {skill}
                              </span>
                            ))}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col>
                        <hr />
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col>
                        <div className="d-flex justify-content-start gap-2">
                          <div className="d-flex align-items-center">
                            <span className="mdi mdi-briefcase-outline me-1"></span>
                            <span>{candidateData?.totalExperience}+</span>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="mdi mdi-map-marker-outline me-1"></span>
                            <span>{candidateData?.currentLocation}</span>
                          </div>
                          <div className="d-flex align-items-center">
                            <span className="mdi mdi-calendar-blank-outline me-1"></span>
                            <span>
                              {format(
                                new Date(data?.candidate?.createdAt),
                                "dd MMM yyyy"
                              )}
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  {/* <CardBody>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <h6
                        style={{
                          color: "#0A56AE",
                          margin: 0,
                          fontSize: "14px",
                        }}
                      >
                        {jobData?.jobTitle}
                      </h6>
                      <Card
                        key={index}
                        style={{
                          ...getStatusClass(interviewStatus),
                          padding: "5px 10px",
                          display: "inline-flex",
                          marginLeft: "auto",
                          marginBottom: "0px",
                          borderRadius: "10px",
                        }}
                      >
                        Interview {interviewStatus}
                      </Card>
                      <i
                        className="mdi mdi-arrow-right-bold-outline"
                        style={{
                          fontSize: "25px",
                          marginLeft: "10px",
                          color: "#0A4FAE",
                        }}
                      />
                    </div>
                    <h3 style={{ color: "black", fontSize: "22px" }}>
                      {candidateData?.firstName} {candidateData?.lastName}
                    </h3>
                    <span
                      style={{
                        color: "#5E6670",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        overflow: "hidden",
                        marginBottom: "8px",
                        fontSize: "16px",
                      }}
                    >
                      {candidateData?.profileSummary}
                    </span>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "nowrap",
                        gap: "10px",
                        overflowX: "auto",
                        borderBottom: "2px solid #eeeeee",
                      }}
                    >
                      {candidateData?.primarySkill
                        .split(",")
                        .map((skill, index) => (
                          <Card
                            key={index}
                            style={{
                              minWidth: "80px",
                              padding: "8px",
                              textAlign: "center",
                              backgroundColor: "#F9FAFB",
                              borderRadius: "5px",
                              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              flexShrink: 0,
                              marginBottom: "17px",
                            }}
                          >
                            <p
                              style={{
                                margin: 0,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                color: "#7F7F7F",
                              }}
                            >
                              {skill}
                            </p>
                          </Card>
                        ))}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        marginTop: "9px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexGrow: 1,
                        }}
                      >
                        <i
                          className="mdi mdi-briefcase-outline"
                          style={{
                            color: "#0A56AE",
                            marginRight: "8px",
                          }}
                        />
                        <p style={{ margin: 0, color: "#7F7F7F" }}>
                          {candidateData?.totalExperience}+
                        </p>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexGrow: 1,
                        }}
                      >
                        <i
                          className="mdi mdi-map-marker-radius-outline"
                          style={{
                            color: "#0A56AE",
                            marginRight: "8px",
                          }}
                        />
                        <p style={{ margin: 0, color: "#7F7F7F" }}>
                          {candidateData?.currentLocation}
                        </p>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexGrow: 1,
                        }}
                      >
                        <i
                          className="mdi mdi-calendar-blank-outline"
                          style={{
                            color: "#0A56AE",
                            marginRight: "8px",
                          }}
                        />
                        <p style={{ margin: 0, color: "#7F7F7F" }}>
                          {
                            new Date(data.timeline["Submit to Client"][0].date)
                              .toISOString()
                              .split("T")[0]
                          }
                        </p>
                      </div>
                    </div>
                  </CardBody> */}
                </Card>
              );
            })
          ) : (
            <span className="text-muted">
              No candidates have applied for this job listing.
            </span>
          )}
        </Col>
        <Col lg={9}>
          <Nav tabs>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab == 1 })}
                onClick={() => toggle("1")}
              >
                Candidate Portfolio
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: activeTab == 2 })}
                onClick={() => toggle("2")}
              >
                Candidate Pre-Assessment
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col sm="12">
                  <div className="py-3">
                    {/* <span className="text-muted">
                      Candidate Portfolio is not available.
                    </span> */}
                    {selectedCandidate != null ? (
                      <CandidateProfileEditor
                        publicView={true}
                        selectedCandidateId={selectedCandidate?.id}
                      />
                    ) : (
                      <span className="text-muted">
                        Please select a candidate.
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row>
                <Col sm="12">
                  <div className="py-3">
                    <span className="text-muted">
                      Candidate Pre-Assessments are not available.
                    </span>
                  </div>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </div>
  );
}

export default ClientCandidatesTab;
